import { ReduxStateEngineConfigs } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { AppState } from '@store';
import { rootReducer, rootSaga } from '../../store/store';

const reduxStateEngineConfigs: ReduxStateEngineConfigs<AppState> = {
	clientReducers: rootReducer,
	clientSagas: rootSaga,
};
export default reduxStateEngineConfigs;
